<template>
    <div class="message-balon"
         :class="typeBalon">
        <div class="sorriso" v-if="typeBalon == 'right'">
            <img src="../../assets/ballon-right.png" alt="">
        </div>
        <div class="text-balon" v-if="textBalon">
            <span class="text">{{textBalon}}</span>
            <span v-if="nameBalon"
                class="name"
                :style="{color : color.color}">{{nameBalon}}</span>
        </div>
    </div>
</template>
<script>
export default {
    props : {
        typeBalon : {
            type : String,
            required : true
        },
        textBalon : {
            type : String
        },
        nameBalon : {
            type : String
        },
        color: {
            type : Object
        }
    }
}
</script>
<style lang="scss" scoped>
    .message {
        position: relative;
        background: white;
        width: 230px;
        height: 230px;
        box-shadow: 7px 7px 0px 0px rgba(111, 124, 124, 0.082);

        &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            width: 0;
            height: 0;
            border: 41px solid transparent;
            border-top-color: white;
            border-bottom: 0;
            border-right: 0;
            margin-left: -20.5px;
            margin-bottom: -41px;
        }

        .text-balon{

            width: 80%;
            height: 100%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;

            .text{
                color : #576066;
                font-size: 15px;
                line-height: 23px;
            }

            .name{
                font-weight: bold;
                text-transform: uppercase;
                font-size: 11px;
                margin-top: 15px;
                text-overflow: ellipsis; 
                white-space: nowrap;
                overflow: hidden;
                width: 120px;
            }
        }
    }

    .right{

        img{
            height: 60px;
        }
    }

    @media only screen and (min-height: 700px){
        .message{
            width: 300px;
            height: 300px;
            
            .text-balon{

                .text{
                    font-size: 18px;
                }
                
                .name{
                    font-size: 14px;
                    width: 150px;
                }
            }
        }
    }

    @media only screen and (min-width: 700px){
        .message{
            width: 400px;
            height: 320px;
        }
    }
</style>
